import React from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { PlatformContext } from "../components/Platform/PlatformContext";

const Impressum: React.FC = () => {
  let navigate = useNavigate();
  let platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  return (
    <div className="flex flex-col w-screen items-center justify-center">
      <h1 className="text-3xl font-bold text-white mt-10">Impressum</h1>

      <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-lg p-6 m-6 max-w-3xl text-white shadow-lg border border-white/20">
        {/* Impressum */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">Angaben gemäß § 5 TMG</h2>
          <p>
            Im Folgenden finden Sie die gesetzlich vorgeschriebenen Angaben
            gemäß § 5 Telemediengesetz (TMG):
          </p>

          <div className="mt-4">
            <p className="mb-4">
              <strong>Faculties Football League e.V.</strong>
              <br />
              Arcisstraße 17, c/o Studentische Vertretung
              <br />
              80333 München
              <br />
              Deutschland
            </p>

            <p className="mb-4">
              <strong>Vertreten von:</strong>
              <br />
              Levi Frim, Vorstandsvorsitzender
              <br />
              E-Mail:{" "}
              <a
                href="mailto:levi.frim@facultiesfootballleague.de"
                className="text-blue-300 underline"
              >
                levi.frim@facultiesfootballleague.de
              </a>
              <br />
            </p>
            <strong>Registereintrag:</strong>
            <p>Vereinsregister des Amtsgerichts München</p>
            <p>Registernummer: VR 211297</p>
          </div>

          <div className="mt-4">
            <h3 className="text-xl font-medium mb-2">Haftungsausschluss</h3>
            <p>
              Die Inhalte dieser Website dienen ausschließlich allgemeinen
              Informationszwecken. Wir übernehmen keine Haftung für die
              Richtigkeit, Vollständigkeit oder Verfügbarkeit der
              bereitgestellten Informationen. Für den Inhalt externer verlinkter
              Seiten sind wir nicht verantwortlich.
            </p>
          </div>

          <div className="mt-4">
            <h3 className="text-xl font-medium mb-2">Urheberrecht</h3>
            <p>
              Alle Inhalte dieser Website, soweit nicht anders angegeben, sind
              Eigentum des Faculties Football League e.V. und urheberrechtlich
              geschützt. Eine Vervielfältigung oder Verbreitung ohne vorherige
              Zustimmung ist untersagt.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
